import { render } from "./BaseNavbar.vue?vue&type=template&id=90d17858"
import script from "./BaseNavbar.vue?vue&type=script&lang=js"
export * from "./BaseNavbar.vue?vue&type=script&lang=js"
script.render = render

export default script